import { useState, useEffect } from "react";
import style from "./ShipperDetail.module.css"; // assuming CSS module

const ShipperDetailTable = ({
  actions,
  data,
  onChange,
  isReset,
  isCustomColumn = false,
}) => {
  const [selected, setSelected] = useState({});

  useEffect(() => {
    if (isReset) {
      setSelected({});
      onChange({});
    }
  }, [isReset, onChange]);

  const handleRowClick = (rowId, actionId) => {
    const updated = { ...selected };
    // Toggle selection
    updated[rowId] = updated[rowId] === actionId ? null : actionId;
    setSelected(updated);
    onChange(updated);
  };

  // const handleApplyToAll = (actionId) => {
  //   const updated = {};
  //   data.forEach((row) => {
  //     updated[row.drugId] = actionId;
  //   });
  //   setSelected(updated);
  //   onChange(updated);
  // };

  const handleApplyToAll = (actionId) => {
    // Check if all rows are already selected with the same actionId
    const allSelected = data.every((row) => selected[row.drugId] === actionId);

    const updated = {};

    if (allSelected) {
      // Unselect all
      data.forEach((row) => {
        updated[row.drugId] = null;
      });
    } else {
      // Select all with the given actionId
      data.forEach((row) => {
        updated[row.drugId] = actionId;
      });
    }

    setSelected(updated);
    onChange(updated);
  };

  return (
    <div className={style.tableWrapper}>
      <table className={style.table}>
        <thead>
          <tr>
            <th
              className={`${style.thSpacing} ${
                !isCustomColumn ? style.firstCol : style?.customFirstColumn
              }`}
            >
              Drug Kit Number
            </th>
            <th className={style.thSpacing}>Current Status</th>
            {actions.map((action, index) => (
              <th key={index} className={style.thSpacing}>
                <button
                  type="button"
                  style={{ height: "30px" }}
                  className={`${"create-btn-outlined"} small-button`}
                  onClick={() => handleApplyToAll(action.id)}
                >
                  {data.length > 0 &&
                  data.every((row) => selected[row.drugId] === action.id)
                    ? "Unselect All"
                    : "Apply To All"}
                </button>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index} className={style.trBorder}>
              <td
                className={`${style.thSpacing} ${
                  !isCustomColumn ? style.firstCol : style?.customFirstColumn
                }`}
              >
                {row.drugKitNumber}{" "}
                {row?.packingType ? ` (${row.packingType})` : ""}
              </td>
              <td className={style.thSpacing}>{row?.statusText}</td>
              {actions.map((action, index) => (
                <td key={index} className={style.thSpacing}>
                  <button
                    type="button"
                    style={{
                      width: "180px",
                    }}
                    className={`${
                      selected[row.drugId] === action.id
                        ? "create-btn"
                        : "create-btn-outlined"
                    } small-button`}
                    onClick={() => handleRowClick(row.drugId, action.id)}
                  >
                    {action.description}
                  </button>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ShipperDetailTable;
